import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { storeElement } from 'GlobalStores/Cores/Elements/StoreElement'
import { Stack, Typography, styled, Box } from '@mui/material'
import { runInAction } from 'mobx'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import StoreProducts from 'GlobalStores/StoreProducts'
import StoreUser from 'GlobalStores/User/StoreUser'
import { ReactComponent as RefreshIcon } from './Assets/RefreshIcon.svg'
// import order2 from '../order.json'
// import payment from '../payment.json'
import { T, useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import ItemSubscriptionsMobile from './ItemSubscriptionsMobile'
import { useNavigate } from 'react-router-dom'
import { DefaultButton } from '../../Forms'
import { ReactComponent as RefreshSVG } from './Assets/iconRefreshDesktop.svg'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import { useSizeWindow } from 'Helpers/GlobalHelpers'
import defaultItem from '../defaultItemSgp.json'

const SubscriptionsMobile = observer(props => {
    const [paymentData, setPaymentData] = useState([])
    const [loading, setLoading] = useState(false)
    const [orderData, setOrderData] = useState([])

    useEffect(() => {
        runInAction(() => {
            storeElement.cardTitle.titleStep1 = <T>subscriptions</T>
            storeElement.settingCard.padding = '0'
        })

        if (orderData.length === 0) {
            getOrder()
        }

        return () => {
            runInAction(() => {
                storeElement.cardTitle.titleStep1 = ''
                storeElement.settingCard.padding = ''
            })
        }
    }, [])

    const getOrder = async () => {
        setLoading(true)
        try {
            const response = await FeelGreatAPI.GetSubscriptions(StoreAuth.GetToken())
            if (response) {
                const filterData = await Promise.all(
                    response.data.data
                        .filter(item => item.market === (StoreCountry.Country2() === 'AE' ? 'UE' : StoreCountry.Country2()))
                        .map(async data => {
                            let useData = { ...data }

                            let jpStyle = null
                            if (useData.market === 'JP') {
                                jpStyle = await FeelGreatAPI.GetSubscriptionsItems(StoreAuth.GetToken(), data.href)
                                useData = {
                                    ...useData,
                                    lines: jpStyle?.data?.lines,
                                    recurrence: jpStyle?.data?.recurrence,
                                    shipToAddress: jpStyle?.data?.shipToAddress,
                                    transactions: jpStyle?.data?.transactions,
                                    terms: jpStyle?.data?.terms,
                                    shippingMethod: jpStyle?.data?.shippingMethod,
                                    shipToEmail: jpStyle?.data?.shipToEmail
                                }
                            }
                            return {
                                ...useData,
                                productItem: useData.lines.items
                                    .map(lineItem => {
                                        let createdItem = {
                                            ...StoreProducts.GetProductByItemCode(lineItem.item.id.unicity),
                                            quantity: lineItem.quantity
                                        }

                                        return createdItem
                                    })
                                    .filter(createdItem => Object.keys(createdItem).length > 1)
                            }
                        })
                )

                setOrderData(filterData)

                const responsePayment = await FeelGreatAPI.Creditcardaliases(StoreAuth.GetToken(), StoreUser.CustomerData().Country())
                if (responsePayment) {
                    setPaymentData(responsePayment.data)
                }
                setLoading(false)
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    return (
        <SubscriptionsStyled loading={loading ? 1 : 0}>
            {loading && <IconSpinner />}
            {!loading && orderData.length === 0 && <NoSubscriptions />}
            {!loading && orderData.length !== 0 && <ItemSubscriptionsMobile order={orderData} payment={paymentData} getOrder={getOrder} />}
        </SubscriptionsStyled>
    )
})

const NoSubscriptions = observer(props => {
    const navigate = useNavigate()
    const translate = useTranslate()

    const { width } = useSizeWindow()

    useEffect(() => {
        runInAction(() => {
            storeElement.settingCard.padding = '0 30px'
        })

        return () => {
            runInAction(() => {
                storeElement.settingCard.padding = ''
            })
        }
    }, [])

    return (
        <Wrapper>
            <Stack textAlign="center" justifyContent="center" alignItems="center" height="100%">
                <RefreshSVG />

                <Typography variant="title" mt="30px" mb="20px" fontSize="24px">
                    <T>no_subscriptions</T>
                </Typography>

                <Typography variant="caption5" textAlign={'center'} mb="40px" color="#023764">
                    <T>no_subscription_description</T>
                </Typography>

                <DefaultButton
                    type="submit"
                    fullWidth={true}
                    titleText={translate('buy_now')}
                    width={width < 428 ? '100%' : '344px'}
                    backgroundcolor="#003B6F"
                    fontSize="20px"
                    fontWeight="400"
                    onClick={() => navigate('/products')}
                />
            </Stack>
        </Wrapper>
    )
})

const Wrapper = styled(Box)`
    height: 554px;
    width: 100%;
    background: #ffffff;
    display: flex;
    justify-content: center;
`

const SubscriptionsStyled = styled(Stack)`
    justify-content: ${props => (props.loading ? 'center' : 'flex-start')};
    align-items: center;
    min-height: ${props => (props.loading ? '554px' : '100%')};
    height: 100%;
    background: ${props => (props.loading ? '#ffffff' : '#d1d9e2')};
    gap: 15px;
    border-radius: ${props => (props.loading ? '12px' : '0')};
`

const IconSpinner = styled(RefreshIcon)`
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    width: 65px;
    height: 65px;

    circle {
        stroke: #e2e8ed;
    }
    path {
        stroke: #e2e8f2;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`

export default SubscriptionsMobile
